import { OpenApiDocument, OpenApiOperation } from '../../api/documentation.api';

export interface WebhookOperationModel extends OpenApiOperation {
    name: string;
    method: string;
}

export function getWebhookOperations(doc: OpenApiDocument): WebhookOperationModel[] {
    // Transform { [name]: { [method]: ... } } into { name, method, ... }[]:
    return Object.entries(doc.webhooks ?? [])
        .map(([name, methods]) =>
            Object.entries(methods).map(([method, operation]) => ({
                name,
                method: method.toUpperCase(),
                ...operation,
            })),
        )
        .flat(2);
}
